import { CircleDollarSign } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CurrencyIconProps {
	code: string
	symbolUrl?: string
	className?: string
	size?: 'sm' | 'md' | 'lg'
}

const SIZE_CLASSES = {
	sm: 'h-6 w-6',
	md: 'h-8 w-8',
	lg: 'h-10 w-10',
} as const

export function CurrencyIcon({ code, symbolUrl, className, size = 'md' }: CurrencyIconProps) {
	if (symbolUrl) {
		return <img src={symbolUrl} alt={code} className={cn('shrink-0 rounded-full object-cover', SIZE_CLASSES[size], className)} />
	}

	return (
		<span className={cn('flex shrink-0 items-center justify-center rounded-full bg-secondary text-muted-foreground', SIZE_CLASSES[size], className)} aria-label={code}>
			<CircleDollarSign className='h-2/3 w-2/3' aria-hidden />
		</span>
	)
}
